import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const SessionExpiredDialog = ({ open, onConfirm }) => {
  return (
    <Dialog open={open} disableEscapeKeyDown>
      <DialogTitle>Session Expired</DialogTitle>

      <DialogContent>
        <Typography>
          Someone is already logged in with this teacher on another device.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" color="error" onClick={onConfirm}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredDialog;
